module.exports = __webpack_public_path__ + "static/media/SFMono-Medium.02bbb638.ttf";